<div *ngIf="!iFrameUrl" class="text-center">
  <div class="spacer spacer--4"></div>
  <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
  <div class="spacer spacer--4"></div>
</div>

<div
  #oxioMetricsIFrame
  class="oxio-metrics-wrapper"
  [ngStyle]="{ 'height.px': oxioMetricsHeight }"
>
  <iframe
    *ngIf="iFrameUrl"
    [src]="iFrameUrl"
    frameborder="0"
    [height]="oxioMetricsHeight"
  >
    <p>Browser does not Support iFrames</p>
  </iframe>
</div>
<div id="oxio-metrics-iframe-target"></div>
<nz-back-top></nz-back-top>
